@if(visible) {
<div class="flex flex-col h-full bg-white gap-2">
    <!-- Header -->
    <div class="flex items-center justify-between">
        <div class="flex items-center gap-1">
            <app-icon type="pi pi-chevron-left" source="primeng" (click)="handleClose()" size="default"
                class="cursor-pointer"></app-icon>
            <h3 class="text-lg font-semibold text-gray-900">Add project tags</h3>
        </div>
    </div>

    <!-- Search Bar -->
    <div class="pt-2">
        <app-search-bar placeholder="Search" [(ngModel)]="searchValue" (ngModelChange)="onSearchChange($event)"
            width="100%">
        </app-search-bar>
    </div>

    <!-- Tags List -->
    <div class="flex-1 overflow-y-auto">
        @if(loading) {
        <div class="flex items-center justify-center py-8">
            <div class="loader"></div>
        </div>
        } @else {
        @if(filteredTagTypes.length === 0) {
        <div class="flex items-center justify-center py-8">
            <span class="text-gray-400 text-sm">No tags found</span>
        </div>
        } @else {
        <div>
            @for(tag of filteredTagTypes; track tag._id) {
            <div class="flex gap-3 py-2 flex-1 justify-between items-center border-b border-gray-200">
                <div class="flex flex-col gap-1">
                    <div class="text-sm font-semibold text-gray-900">{{ tag.name }}</div>
                    <div class="text-xs text-gray-500 ">{{ tag.dataType }}</div>
                </div>
                <div class="cursor-pointer flex flex-col items-center gap-0.5 relative">
                    <app-icon class="text-arena-orange-800" type="pi pi-copy" source="primeng" (click)="copyTag(tag)"
                        size="lg" />
                    @if(copiedTagId === tag._id) {
                    <span class="text-xs font-medium">Copied</span>
                    }
                </div>
            </div>
            }
        </div>
        }
        }
    </div>

    <!-- Note and Insert Button -->
    <!-- <div>
        <p class="text-xs text-gray-600 mb-4">
            Note: Place the cursor on the doc and click on insert to insert the tag.
        </p>
        <app-button variant="filled" severity="primary" label="Insert" (clicked)="onInsertClick()"
            [disabled]="selectedTagTypes.size === 0" class="w-full">
        </app-button>
    </div> -->
</div>
}